import { MultiSelectDropdown } from ".";
import useCompaniesOptions from "../hooks/useCompaniesOptions";

const CompaniesDropdown = ({ selectedCompanies, setSelectedCompanies, selectedTiers, selectedStatus, selectedAccountExecutive }) => {
    const { companiesOptions } = useCompaniesOptions({
        selectedTiers,
        selectedStatus,
        selectedAccountExecutive
    });

    return (
        <MultiSelectDropdown
            value={selectedCompanies}
            onChange={setSelectedCompanies}
            options={companiesOptions}
            placeholder="All Companies"
            searchable
            searchPlaceholder="Search company..."
        />
    );
};

export default CompaniesDropdown;
